<div class="language-support">

  <p class="section-title" translate="reg-form.lang-support"></p>

  <div class="form-checkboxes">
    <mat-checkbox (click)="service.checkboxChanges(i, element.checked)" *ngFor="let language of service.languages;let i = index" [checked]="language.checked" #element>{{ language.display }}</mat-checkbox>
  </div>

</div>
